import React from 'react'

interface Props {
  predicted?: Record<string, number> | null
  actual?: Record<string, number> | null
  live?: Record<string, number> | null
  hidden?: boolean
  hiddenLabel?: string
}

function toOrdered(map?: Record<string, number> | null): Array<{ driver: string; position: number }> {
  if (!map) return []
  return Object.entries(map)
    .map(([driver, position]) => ({ driver, position: Number(position) }))
    .filter((row) => row.position >= 1 && row.position <= 10)
    .sort((a, b) => a.position - b.position)
}

const Formula1PredictedGrid: React.FC<Props> = ({
  predicted,
  actual,
  live,
  hidden,
  hiddenLabel,
}) => {
  if (hidden) {
    return (
      <p className="text-sm text-muted-foreground italic">
        {hiddenLabel || 'Grids are hidden until 1 hour before the race.'}
      </p>
    )
  }
  const predRows = toOrdered(predicted)
  const actualMap = actual || live || null
  if (predRows.length === 0 && !actualMap) return null

  return (
    <ol className="space-y-1">
      {Array.from({ length: 10 }, (_, i) => i + 1).map((pos) => {
        const pred = predRows.find((r) => r.position === pos)
        const actualDriver = actualMap
          ? Object.entries(actualMap).find(([, p]) => Number(p) === pos)?.[0]
          : undefined
        const match = Boolean(pred && actualDriver && pred.driver === actualDriver)
        return (
          <li
            key={pos}
            className={`flex items-center justify-between gap-2 text-sm rounded-lg px-2 py-1 ${
              actualMap ? (match ? 'bg-emerald-500/15' : 'bg-destructive/10') : 'bg-muted/30'
            }`}
          >
            <span className="font-semibold w-8 shrink-0">P{pos}</span>
            <span className="flex-1 truncate">{pred?.driver || '—'}</span>
            {actualDriver && (
              <span className={`truncate text-right ${match ? 'text-emerald-300' : 'text-muted-foreground'}`}>
                {actualDriver}
              </span>
            )}
          </li>
        )
      })}
    </ol>
  )
}

export default Formula1PredictedGrid
